import { NavLink, useLocation } from 'react-router-dom'
import { Settings, Package, Folder, ShoppingCart, Users, Mail, LayoutGrid, ChevronLeft, ChevronRight, Film, Image, ChevronDown, ChevronUp, Calendar } from 'lucide-react'
import { useState } from 'react'

const AdminMenu = ({ collapsed = false, onToggle }) => {
  const location = useLocation()
  const [expandedMenus, setExpandedMenus] = useState({})
  
  const items = [
    { id: 'dashboard', name: 'Dashboard', icon: LayoutGrid, to: '/admin' },
    { id: 'products', name: 'Produits', icon: Package, to: '/admin/products' },
    { id: 'categories', name: 'Catégories', icon: Folder, to: '/admin/categories' },
    { id: 'orders', name: 'Commandes', icon: ShoppingCart, to: '/admin/orders' },
    { id: 'users', name: 'Clients', icon: Users, to: '/admin/users' },
    { id: 'mails', name: 'Mails', icon: Mail, to: '/admin/mails' },
    { id: 'filmographie', name: 'Filmographie', icon: Film, to: '/admin/filmographie' },
    { id: 'banners', name: 'Bannières', icon: Image, to: '/admin/banners' },
    { id: 'popup-event', name: 'PopUp Event', icon: Calendar, to: '/admin/popup-event' },
    { id: 'settings', name: 'Paramètres', icon: Settings, to: '/admin/settings' }
  ]
  
  const toggleMenu = (menuId) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }))
  }

  return (
    <div className={`card ${collapsed ? 'px-2 py-3' : ''}`}>
      <div className={`flex items-center ${collapsed ? 'justify-center' : 'justify-between'} mb-2`}>
        {!collapsed && <span className="text-sm font-semibold text-gray-700">Menu</span>}
        {typeof onToggle === 'function' && (
          <button
            type="button"
            onClick={onToggle}
            className="h-8 w-8 flex items-center justify-center rounded-md border border-gray-200 hover:bg-gray-50"
            aria-label={collapsed ? 'Déployer le menu' : 'Réduire le menu'}
            title={collapsed ? 'Déployer le menu' : 'Réduire le menu'}
          >
            {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
          </button>
        )}
      </div>
      <nav className="space-y-2">
        {items.map((tab) => {
          const Icon = tab.icon
          const isActive = location.pathname === tab.to || (tab.subItems && tab.subItems.some(subItem => location.pathname === subItem.to))
          const isExpanded = expandedMenus[tab.id]
          
          return (
            <div key={tab.id}>
              {tab.subItems ? (
                // Menu avec sous-éléments
                <div>
                  <button
                    onClick={() => toggleMenu(tab.id)}
                    className={`w-full flex items-center justify-between p-3 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-orange-50 border border-orange-200 text-orange-700'
                        : 'hover:bg-gray-50 border border-transparent text-gray-700'
                    }`}
                  >
                    <div className="flex items-center">
                      <Icon className={`h-5 w-5 ${collapsed ? '' : 'mr-3'} ${isActive ? 'text-orange-600' : 'text-gray-500'}`} />
                      {!collapsed && <span className="font-medium">{tab.name}</span>}
                    </div>
                    {!collapsed && (
                      isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />
                    )}
                  </button>
                  
                  {/* Sous-éléments */}
                  {!collapsed && isExpanded && (
                    <div className="ml-6 mt-1 space-y-1">
                      {tab.subItems.map((subItem) => {
                        const SubIcon = subItem.icon
                        const isSubActive = location.pathname === subItem.to
                        return (
                          <NavLink
                            key={subItem.id}
                            to={subItem.to}
                            className={`w-full flex items-center p-2 rounded-lg transition-colors text-sm ${
                              isSubActive
                                ? 'bg-orange-50 border border-orange-200 text-orange-700'
                                : 'hover:bg-gray-50 border border-transparent text-gray-600'
                            }`}
                          >
                            <SubIcon className={`h-4 w-4 mr-2 ${isSubActive ? 'text-orange-600' : 'text-gray-500'}`} />
                            <span className="font-medium">{subItem.name}</span>
                          </NavLink>
                        )
                      })}
                    </div>
                  )}
                </div>
              ) : (
                // Menu simple
                <NavLink
                  to={tab.to}
                  title={tab.name}
                  className={`w-full flex items-center p-3 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-orange-50 border border-orange-200 text-orange-700'
                      : 'hover:bg-gray-50 border border-transparent text-gray-700'
                  }`}
                >
                  <Icon className={`h-5 w-5 ${collapsed ? '' : 'mr-3'} ${isActive ? 'text-orange-600' : 'text-gray-500'}`} />
                  {!collapsed && <span className="font-medium">{tab.name}</span>}
                </NavLink>
              )}
            </div>
          )
        })}
      </nav>
    </div>
  )
}

export default AdminMenu


